import childSavingTextsDe from './de/childSavingTexts.json'
import commonTextsDe from './de/commonTexts.json'
import contentsNxtTextsDe from './de/contentsNxtTexts.json'
import contentsTextsDe from './de/contentsText.json'
import dentalTextsDe from './de/dentalTexts.json'
import dogLiabilityNxtTextsDe from './de/dogLiabilityNxtTexts.json'
import dogTextsDe from './de/dogTexts.json'
import droneTextsDe from './de/droneTexts.json'
import householdAtTextsDe from './de/householdAtTexts.json'
import incomeProtectionTextsDe from './de/incomeProtectionTexts.json'
import legalTextsDe from './de/legalTexts.json'
import liabilityNxtTextsDe from './de/liabilityNxtTexts.json'
import liabilityTextsDe from './de/liabilityTexts.json'
import mgaCommonTextsDe from './de/mgaCommonTexts.json'
import petHealthTextsDe from './de/petHealthTexts.json'
import petHealthTransferOptInTextsDe from './de/petHealthTransferOptInTexts.json'
import petHealthTransferOptOutTextsDe from './de/petHealthTransferOptOutTexts.json'
import petHealthV2TextsDe from './de/petHealthV2Texts.json'
import privateHealthTextsDe from './de/privateHealthTexts.json'
import privatePensionTextsDe from './de/privatePensionTexts.json'
import publicHealthTextsDe from './de/publicHealthTexts.json'
import termLifeTextsDe from './de/termLifeTexts.json'
import travelHealthTextsDe from './de/travelHealthTexts.json'
import childSavingTextsEn from './en/childSavingTexts.json'
import commonTextsEn from './en/commonTexts.json'
import contentsNxtTextsEn from './en/contentsNxtTexts.json'
import contentsTextsEn from './en/contentsText.json'
import dentalTextsEn from './en/dentalTexts.json'
import dogLiabilityNxtTextsEn from './en/dogLiabilityNxtTexts.json'
import dogTextsEn from './en/dogTexts.json'
import droneTextsEn from './en/droneTexts.json'
import householdAtTextsEn from './en/householdAtTexts.json'
import incomeProtectionTextsEn from './en/incomeProtectionTexts.json'
import legalTextsEn from './en/legalTexts.json'
import liabilityNxtTextsEn from './en/liabilityNxtTexts.json'
import liabilityTextsEn from './en/liabilityTexts.json'
import mgaCommonTextsEn from './en/mgaCommonTexts.json'
import petHealthTextsEn from './en/petHealthTexts.json'
import petHealthTransferOptInTextsEn from './en/petHealthTransferOptInTexts.json'
import petHealthTransferOptOutTextsEn from './en/petHealthTransferOptOutTexts.json'
import petHealthV2TextsEn from './en/petHealthV2Texts.json'
import privateHealthTextsEn from './en/privateHealthTexts.json'
import privatePensionTextsEn from './en/privatePensionTexts.json'
import publicHealthTextsEn from './en/publicHealthTexts.json'
import termLifeTextsEn from './en/termLifeTexts.json'
import travelHealthTextsEn from './en/travelHealthTexts.json'

// [hygen-marker] import

export const translations = {
  de: {
    sharedFlows_common: commonTextsDe,
    sharedFlows_mgaCommon: mgaCommonTextsDe,
    sharedFlows_contentsNxt: contentsNxtTextsDe,
    sharedFlows_contents: contentsTextsDe,
    sharedFlows_dental: dentalTextsDe,
    sharedFlows_dogLiabilityNxt: dogLiabilityNxtTextsDe,
    sharedFlows_dog: dogTextsDe,
    sharedFlows_drone: droneTextsDe,
    sharedFlows_householdAt: householdAtTextsDe,
    sharedFlows_legal: legalTextsDe,
    sharedFlows_liability: liabilityTextsDe,
    sharedFlows_liabilityNxt: liabilityNxtTextsDe,
    sharedFlows_petHealth: petHealthTextsDe,
    sharedFlows_petHealthV2: petHealthV2TextsDe,
    sharedFlows_incomeProtection: incomeProtectionTextsDe,
    sharedFlows_privatePension: privatePensionTextsDe,
    sharedFlows_privateHealth: privateHealthTextsDe,
    sharedFlows_childSaving: childSavingTextsDe,
    sharedFlows_termLife: termLifeTextsDe,
    sharedFlows_petHealthTransferOptOut: petHealthTransferOptOutTextsDe,
    sharedFlows_petHealthTransferOptIn: petHealthTransferOptInTextsDe,
    sharedFlows_travelHealth: travelHealthTextsDe,
    sharedFlows_publicHealth: publicHealthTextsDe,
    // [hygen-marker] export de
  },
  en: {
    sharedFlows_common: commonTextsEn,
    sharedFlows_mgaCommon: mgaCommonTextsEn,
    sharedFlows_contentsNxt: contentsNxtTextsEn,
    sharedFlows_contents: contentsTextsEn,
    sharedFlows_dental: dentalTextsEn,
    sharedFlows_dogLiabilityNxt: dogLiabilityNxtTextsEn,
    sharedFlows_dog: dogTextsEn,
    sharedFlows_drone: droneTextsEn,
    sharedFlows_householdAt: householdAtTextsEn,
    sharedFlows_legal: legalTextsEn,
    sharedFlows_liability: liabilityTextsEn,
    sharedFlows_liabilityNxt: liabilityNxtTextsEn,
    sharedFlows_petHealth: petHealthTextsEn,
    sharedFlows_petHealthV2: petHealthV2TextsEn,
    sharedFlows_incomeProtection: incomeProtectionTextsEn,
    sharedFlows_privatePension: privatePensionTextsEn,
    sharedFlows_privateHealth: privateHealthTextsEn,
    sharedFlows_childSaving: childSavingTextsEn,
    sharedFlows_termLife: termLifeTextsEn,
    sharedFlows_petHealthTransferOptOut: petHealthTransferOptOutTextsEn,
    sharedFlows_petHealthTransferOptIn: petHealthTransferOptInTextsEn,
    sharedFlows_travelHealth: travelHealthTextsEn,
    sharedFlows_publicHealth: publicHealthTextsEn,
    // [hygen-marker] export en
  },
}
